(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["imloi-editorial"] && !Shopify.designMode) return;
  try {
    
function initRoiShopping(root) {
  root.querySelectorAll('.roi-editorial').forEach(section => {
    const controls = section.querySelector('.roi-filters');
    if (!controls || controls.dataset.ready) return;
    controls.dataset.ready = 'true';
    controls.hidden = false;
    const controller = new AbortController();
    const listen = (target, type, handler) => target.addEventListener(type, handler, {signal:controller.signal});
    const cards = [...section.querySelectorAll('.roi-product')];
    const buttons = [...controls.querySelectorAll('button')];
    const track = section.querySelector('.roi-product-grid');
    const transport = section.querySelector('.roi-carousel-controls');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const pauseButton = transport.querySelector('[data-roi-pause]');
    let paused = true;
    let hover = false;
    const updatePause = () => {
      pauseButton.textContent = paused ? '自動送りを再開' : '自動送りを停止';
      pauseButton.setAttribute('aria-pressed', String(paused));
      pauseButton.disabled = motion.matches;
    };
    const pause = () => { paused = true; updatePause(); };
    const apply = category => {
      const categories = category.split(',');
      let count = 0;
      cards.forEach(card => {
        card.hidden = category !== 'all' && !categories.includes(card.dataset.roiCategory);
        if (!card.hidden) count++;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.roiFilter === category)));
      controls.querySelector('.roi-filter-count').textContent = count + '件の詰め合わせ';
      track.scrollTo({left:0,behavior:'instant'});
    };
    const move = direction => {
      const card = cards.find(c => !c.hidden);
      if (!card) return;
      const edge = Math.max(0,track.scrollWidth - track.clientWidth);
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      const current = track.scrollLeft;
      const next = direction > 0
        ? (current >= edge - 2 ? 0 : Math.min(edge,current + step))
        : (current <= 2 ? edge : Math.max(0,current - step));
      track.scrollTo({left:next,behavior:motion.matches ? 'instant' : 'smooth'});
    };
    listen(controls,'click',event => {
      const button = event.target.closest('button[data-roi-filter]');
      if (button) { pause(); apply(button.dataset.roiFilter); }
    });
    section.querySelectorAll('[data-roi-scene]').forEach(link => listen(link,'click',event=>{
      pause();apply(link.dataset.roiScene);
      const target = document.getElementById(link.hash.slice(1));
      if(target && target.classList.contains('roi-product')){
        event.preventDefault();
        target.scrollIntoView({behavior:motion.matches?'instant':'smooth',block:'center',inline:'center'});
        target.focus({preventScroll:true});
      }
    }));
    transport.hidden = false;
    updatePause();
    listen(pauseButton,'click',()=>{paused=!paused;updatePause();});
    listen(transport.querySelector('[data-roi-next]'),'click',()=>{pause();move(1);});
    listen(transport.querySelector('[data-roi-prev]'),'click',()=>{pause();move(-1);});
    listen(track,'pointerenter',()=>{hover=true;});
    listen(track,'pointerleave',()=>{hover=false;});
    listen(track,'pointerdown',pause);
    listen(track,'focusin',pause);
    listen(track,'keydown',event=>{
      if(event.target!==track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
      event.preventDefault();pause();
      if(event.key==='Home'||event.key==='End') track.scrollTo({left:event.key==='Home'?0:track.scrollWidth,behavior:'instant'});
      else move(event.key==='ArrowRight'?1:-1);
    });
    listen(motion,'change',()=>{if(motion.matches)paused=true;updatePause();});
    const timer=setInterval(()=>{
      if(!section.isConnected){clearInterval(timer);controller.abort();return;}
      if(!paused&&!hover&&!motion.matches&&!document.hidden&&!section.contains(document.activeElement))move(1);
    },5000);
    const requestedCategory = new URLSearchParams(location.search).get('roi_category');
    const initialCategory = buttons.some(button => button.dataset.roiFilter === requestedCategory) ? requestedCategory : 'all';
    if (initialCategory !== 'all') pause();
    apply(initialCategory);
  });
}
initRoiShopping(document);
document.addEventListener('shopify:section:load',event=>initRoiShopping(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["imloi-survey"]) return;
  try {
    
function bindRoiSurvey(){document.querySelectorAll('.roi-survey form').forEach(form=>{if(form.dataset.bound)return;form.dataset.bound='true';form.addEventListener('change',event=>{const input=event.target;if(input.type!=='checkbox')return;const fieldset=input.closest('fieldset');if(input.dataset.exclusive&&input.checked){fieldset.querySelectorAll('input[type=checkbox]').forEach(other=>{if(other!==input)other.checked=false;});}else if(input.checked){const none=fieldset.querySelector('[data-exclusive]');if(none)none.checked=false;}});form.addEventListener('submit',()=>{form.querySelector('button[type=submit]').disabled=true;});});}
bindRoiSurvey();document.addEventListener('shopify:section:load',bindRoiSurvey);window.addEventListener('pageshow',()=>document.querySelectorAll('.roi-survey button').forEach(button=>button.disabled=false));

  } catch(e) { console.error(e); }
})();
})();
